__turbopack_context__.v({
  "face": "avatar-stack-module__SEExTa__face",
  "more": "avatar-stack-module__SEExTa__more",
  "stack": "avatar-stack-module__SEExTa__stack",
});
